import { Injector } from '@angular/core';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { functionCtaType } from '../cta-button-actions.utils';
import { saveTransactionNote } from '../transactions-actions/save-transaction-note/save-transaction-note.utils';
import { editTransactionNote } from '../transactions-actions/save-transaction-note/edit-transaction-note.utils';

export const transactionManagementActions: Map<ButtonActionType, functionCtaType> = new Map([
  [
    ButtonActionType.SAVE_TRANSACTION_NOTE,
    (injector: Injector, widgetAttributes: UiZoneWidgetAttributeConfig) => {
      saveTransactionNote(injector, widgetAttributes);
    },
  ],
  [
    ButtonActionType.EDIT_TRANSACTION_NOTE,
    (injector: Injector, widgetAttributes: UiZoneWidgetAttributeConfig) => {
      editTransactionNote(injector, widgetAttributes);
    },
  ],
]);
